import { useEffect, useState } from 'react';
import { Loader2, Users } from 'lucide-react';
import api from '../lib/api';
import { SubcoLogo, TagChip } from '../components/subco/SubcoBits';

export default function MySubcoEmployees() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { api.get('/subco-companies/my/employees').then((r) => setData(r.data.data)).catch((e) => setErr(e?.response?.data?.detail || 'Yüklenemedi')); }, []);
  if (err) return <p className="text-sm text-rose-600" data-testid="my-subco-error">{err}</p>;
  if (!data) return <Loader2 className="h-5 w-5 animate-spin text-slate-400" />;
  return (
    <div className="space-y-4" data-testid="my-subco-employees-page">
      <div className="flex items-center gap-3">
        <SubcoLogo subco={data.company} size="h-12 w-12" text="text-base" />
        <div><h1 className="text-2xl font-black">{data.company.name}</h1><p className="text-sm text-slate-500 flex items-center gap-1"><Users className="h-4 w-4" />{data.employees.length} çalışan</p></div>
      </div>
      <div className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 divide-y divide-slate-100 dark:divide-slate-800">
        {data.employees.length === 0 && <p className="p-6 text-sm text-slate-400 text-center">Henüz çalışan yok</p>}
        {data.employees.map((e) => (
          <div key={e.id} className="p-3 flex flex-wrap items-center gap-3 text-sm" data-testid={`my-subco-emp-${e.id}`}>
            <span className="font-semibold min-w-[160px]">{e.full_name}</span>
            <span className="text-slate-500">{e.email}</span>
            <span className="text-slate-500">{e.gsm || '—'}</span>
            <span className="rounded bg-indigo-50 text-indigo-700 px-1.5 py-0.5 text-[11px] font-semibold">{e.firm_name || '—'}</span>
            {(e.tags || []).map((t) => <TagChip key={t} tag={t} active />)}
          </div>
        ))}
      </div>
    </div>
  );
}
